import { useQuery, UseQueryResult } from 'react-query';
import { Customer } from '@indicium/common';
import { customers } from '../../services/nestApiService';
import { ErrorResponse } from 'src/types/NestAPI';

export const useCustomersQuery = (): UseQueryResult<
  Customer[],
  ErrorResponse
> => useQuery(['customers'], () => customers.findAll().then((r) => r.data));
